import api from '@shared/services/api';

export const calendarService = {
    getCalendar: async (year, month) => {
        try {
            const params = {
                year: year,
                month: month,
            };
            const response = await api.get('/calens', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching calendar:', error);
            throw error;
        }
    },
    createCalendar: async (year, month) => {
        try {
            const response = await api.post('/calens', {
                year: year,
                month: month
            });
            return response.data;
        } catch (error) {
            console.error('Error creating calendar:', error);
            throw error;
        }
    },
    updateCalendarDay: async (id, newStatus) => {
        try {
            const response = await api.put(`/calens/${id}`, null, {
                params: {
                    newStatus: newStatus
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error updating calendar day:', error);
            throw error;
        }
    }
};